import { render, staticRenderFns } from "./letter-batch-print.vue?vue&type=template&id=996c41da&scoped=true"
import script from "./letter-batch-print.vue?vue&type=script&lang=ts"
export * from "./letter-batch-print.vue?vue&type=script&lang=ts"
import style0 from "./letter-batch-print.vue?vue&type=style&index=0&id=996c41da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "996c41da",
  null
  
)

export default component.exports